/**
 * IMPORTS
 */

/**
 * Capitaliza a primeira letra de uma string
 * e transforma o restante em minúsculo.
 *
 * @example
 * capitalize("HELLO") -> "Hello"
 * capitalize("wORLD") -> "World"
 */
export const capitalize = (value?: string | null): string => {
  if (!value?.trim()) return "";

  const normalized = value.trim();

  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};
